import Vue from "vue";
import VueYoutube from "vue-youtube";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import "./init";
import VueRx from "vue-rx";
import VueTheMask from "vue-the-mask";

Vue.use(VueRx);
Vue.use(VueYoutube);
Vue.use(VueTheMask);

Vue.config.productionTip = false;

Vue.directive("clickaway", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

new Vue({
  vuetify,
  VueYoutube,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
